import type { FC } from "react";
import React from "react";

import { identity } from "@core/foundation/function";

import { useZodForm } from "@react/foundation/react-hook-form";
import { Button } from "@react/ui-primitives/button";
import {
  Field,
  FieldContent,
  FieldError,
  FieldLabel,
} from "@react/ui-primitives/field";
import { Input } from "@react/ui-primitives/input";

import { memoryApi } from "@apis/memory/api";

import { useMemoryActions } from "../hooks/useMemoryActions.ts";

export const CreateProjectForm: FC = () => {
  const { createProject } = useMemoryActions();
  const form = useZodForm({
    defaultValues: { name: "" },
    errorMapping: { name: { required: "Project name is required." } },
    onSubmit: async values => {
      await createProject.mutateAsync(values, {
        onSuccess: () => {
          form.reset();
        },
      });
    },
    schema: memoryApi.endpoints.createProject.body,
    transform: identity,
  });

  return (
    <form onSubmit={form.handleSubmit}>
      <fieldset className="space-y-2" disabled={form.state.isSubmitting}>
        <Field>
          <FieldLabel>New project</FieldLabel>
          <FieldContent>
            <Input placeholder="Project name" {...form.register("name")} />
            <FieldError errors={[form.state.errors.name]} />
          </FieldContent>
        </Field>
        <Button disabled={!form.state.isValid} type="submit">
          {form.state.isSubmitting ? "Creating…" : "Create project"}
        </Button>
      </fieldset>
    </form>
  );
};
